//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoSliderBasic from './demos/DemoSliderBasic.vue'
import DemoSliderColors from './demos/DemoSliderColors.vue'
import DemoSliderDisabledAndReadonly from './demos/DemoSliderDisabledAndReadonly.vue'
import DemoSliderIcons from './demos/DemoSliderIcons.vue'
import DemoSliderDiscrete from './demos/DemoSliderDiscrete.vue'
import DemoSliderMinAndMax from './demos/DemoSliderMinAndMax.vue'
import DemoSliderStep from './demos/DemoSliderStep.vue'
import DemoSliderValidation from './demos/DemoSliderValidation.vue'
import DemoSliderThumb from './demos/DemoSliderThumb.vue'
import DemoSliderTicks from './demos/DemoSliderTicks.vue'
import DemoSliderVertical from './demos/DemoSliderVertical.vue'
import DemoSliderAppendAndPrepend from './demos/DemoSliderAppendAndPrepend.vue'
import DemoSliderAppendTextField from './demos/DemoSliderAppendTextField.vue'

// code
import {
  sliderBasic,
  sliderColors,
  sliderDisabledAndReadonly,
  sliderIcons,
  sliderDiscrete,
  sliderMinAndMax,
  sliderStep,
  sliderValidation,
  sliderThumb,
  sliderTicks,
  sliderVertical,
  sliderAppendAndPrepend,
  sliderAppendTextField,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoSliderBasic,
    DemoSliderColors,
    DemoSliderDisabledAndReadonly,
    DemoSliderIcons,
    DemoSliderDiscrete,
    DemoSliderMinAndMax,
    DemoSliderStep,
    DemoSliderValidation,
    DemoSliderThumb,
    DemoSliderTicks,
    DemoSliderVertical,
    DemoSliderAppendAndPrepend,
    DemoSliderAppendTextField,
  },
  setup() {
    return {
      codeSnippets: {
        sliderBasic,
        sliderColors,
        sliderDisabledAndReadonly,
        sliderIcons,
        sliderDiscrete,
        sliderMinAndMax,
        sliderStep,
        sliderValidation,
        sliderThumb,
        sliderTicks,
        sliderVertical,
        sliderAppendAndPrepend,
        sliderAppendTextField,
      },
    }
  },
}
